import { createFileRoute } from "@tanstack/react-router";
import { EntryPointsList } from "../../components/entry-points/entry-points-list";
import { entryPointsSearch } from "../../components/entry-points/entry-points-search";
import { requireAdminRole } from "../../lib/auth/guards";

/** `/logistics/arrival-departure/entry-points` — the A&D "Entry points" tab (M9b §3.4): the Game Settings list, admins only, plus her "Peak on {day}" column. */
export const Route = createFileRoute("/_app/logistics/arrival-departure/entry-points")({
	beforeLoad: ({ context }) => requireAdminRole(context.session),
	validateSearch: entryPointsSearch,
	component: EntryPointsRoute,
});

function EntryPointsRoute() {
	const { session } = Route.useRouteContext();
	return <EntryPointsList session={session} search={Route.useSearch()} navigate={Route.useNavigate()} peak />;
}
